import React from 'react'
import styled from 'styled-components'

import { motion } from 'framer-motion';
import { useScroll } from './useScroll';
import { footerTextAnimations }  from '../animation'
function Footer() {
  const[element, controls] = useScroll();

  return (
    <Foot ref={element}>
      <motion.span
       variants={footerTextAnimations}
       animate={controls}
       transition={{
        delay:0.03,
        type: "tween",
        duration: 0.8,
      }}
      >
       <p>  &copy; maruwebfactory All rights reserved;</p>
      </motion.span>
    </Foot>
  )
}
const Foot = styled(motion.footer)`
background-color: var(--primary-color);
color: #fff;
display: flex;
justify-content: center;
align-items: center;
padding: 1rem ;


 
@media screen and (min-width: 280px) and (max-width: 1180px) { 
  padding: 1rem;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
}
`;
export default Footer